import { render, staticRenderFns } from "./AddSourceModal.vue?vue&type=template&id=036b7b8a&scoped=true&"
import script from "./AddSourceModal.vue?vue&type=script&lang=js&"
export * from "./AddSourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b7b8a",
  null
  
)

export default component.exports